import { InfoCircleOutlined } from '@ant-design/icons';
import { theme } from 'antd';
import React from 'react';
import { useDispatch } from 'react-redux';
import { authActions } from 'reduxStore/auth/slice';
import { Button, Flex, Modal, Tooltip, Typography } from 'zui/Antd';
const { Text } = Typography;

const LogoutModal = ({ children, open, setOpen }) => {
	// Hooks
	const {
		token: { colorWarning, marginSM, marginLG, marginXS, marginXXS, fontSizeHeading3, fontSizeLG }
	} = theme.useToken();
	const dispatch = useDispatch();

	// handle sign out
	const handleOkSignOut = () => dispatch(authActions.logout());

	return (
		<>
			<Tooltip title='Log Out' placement='bottom'>
				{children ? (
					children
				) : (
					<Button type='primary' onClick={() => setOpen(true)}>
						Log Out
					</Button>
				)}
			</Tooltip>

			<Modal
				open={open}
				width={400}
				mask={false}
				closeIcon={false}
				centered
				bodyProps={{
					style: {
						margin: `${marginSM}px ${marginXS}px ${marginLG}px`
					}
				}}
				onCancel={() => setOpen(false)}
				footer={[
					<Flex
						justify='end'
						gap={8}
						style={{
							margin: `0px ${marginXS}px ${marginXXS}px`
						}}
					>
						<Button key='cancel' onClick={() => setOpen(false)}>
							Cancel
						</Button>
						<Button key='logout' type='primary' onClick={handleOkSignOut}>
							Log Out
						</Button>
					</Flex>
				]}
			>
				<Flex gap={16} align='start'>
					<InfoCircleOutlined
						style={{
							fontSize: fontSizeHeading3,
							color: colorWarning,
							transform: {
								rotate: 'rotate(90deg)'
							}
						}}
					/>
					<Flex vertical gap={8}>
						<Text strong style={{ fontSize: fontSizeLG, lineHeight: `${fontSizeHeading3}px` }}>
							Log Out
						</Text>
						<Text>Are you sure you want to log out?</Text>
					</Flex>
				</Flex>
			</Modal>
		</>
	);
};

export default LogoutModal;
